import Backend from "i18next-http-backend";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Get saved language from localStorage, or default to "en"
const getSavedLanguage = (): string => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("i18nextLng");
    if (saved && (saved === "en" || saved === "vi" || saved === "fr")) {
      return saved;
    }
  }
  return "en";
};

i18n
  .use(
    new Backend(undefined, {
      requestOptions: {
        cache: "no-cache",
      },
    })
  )
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: getSavedLanguage(), // language to use, loads from localStorage if available
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // Example: i18n.changeLanguage('vi') to switch to Vietnamese
    // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "vi"], // supported languages: English, French and Vietnamese
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on("languageChanged", (lng) => {
  // Save the new language to localStorage
  if (typeof window !== "undefined") {
    localStorage.setItem("i18nextLng", lng);
  }
  console.log("Language changed to:", lng);
});

export default i18n;
